export default __webpack_public_path__ + "static/media/d6f617e034df52a0749ffc344e43ee471582030991241.a5a57fa8.webp";